import Vue from "vue";
import Vuex from "vuex";
import state from "./state";
import mutations from "./mutations";
import getters from "./getters";
import tenant from "./tenant";
import design from "./design";
import app from "./app";

Vue.use(Vuex);

export default new Vuex.Store({
  state,
  mutations,
  getters,
  modules: {
    tenant,
    design,
    app
  }
});



// WEBPACK FOOTER //
// ./src/store/index.js